import React, { useEffect } from "react";

import { Outlet, useLocation } from "react-router-dom";

import { catchAsync, cn, stringifyObjectToRequestQuery } from "src/helpers";
import { MAIN_ROUTES_CONST, RESTRICT_LAYOUT_PATH } from "src/navigations/modules";

import HeaderMain_R from "./Header/HeaderMain_R";

import FooterMain_R from "./Footer/FooterMain_R";

import { sendSystemDetailsApiRequest } from "src/services/requests/Auth";
import { useDispatch } from "react-redux";
import { setUserLoaction } from "src/redux/reducers/tempDataSlice";

type Props = {};

const ReStructureLayoutMain = (props: Props) => {
  const { pathname } = useLocation();

  const PATHS = [...RESTRICT_LAYOUT_PATH].map((d: any) => "/" + d);
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    getMyLocation();
  }, []);

  const getMyLocation = () => {
    const location = window.navigator && window.navigator.geolocation;

    if (location) {
      location.getCurrentPosition(
        (position) => {
          // this.setState()

          handleLocationBalance({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          // this.setState({ latitude: 'err-latitude', longitude: 'err-longitude' })
        }
      );
    }
  };

  const handleLocationBalance = catchAsync(
    async (data: any) => {
      return await sendSystemDetailsApiRequest(stringifyObjectToRequestQuery(data));
    },
    (result: any, data: any) => {
      if (result?.status) {
        dispatch(
          setUserLoaction({
            ...data?.args[0],
            ...result?.data,
          })
        );
      }
    },
    () => {}
  );

  return (
    <div>
      <HeaderMain_R />
      <div
        style={{ overflowAnchor: "none" }}
        className={cn("mt-[80px]", {
          " xl:max-w-[80vw] lg:[90vw]  mx-auto":
            PATHS.includes(pathname) || PATHS.some((path: any) => pathname.includes(path)),
          "pb-[100px]": ![
            MAIN_ROUTES_CONST.welcome,
            MAIN_ROUTES_CONST.commercial_services,
            MAIN_ROUTES_CONST.residential_services,
            MAIN_ROUTES_CONST.schedule_call,
          ]
            .map((d: any) => "/" + d)
            .includes(pathname),
        })}
      >
        <Outlet />
      </div>
      <FooterMain_R />
      {/* <FooterMain/> */}
    </div>
  );
};

export default ReStructureLayoutMain;
